import {DynamicComponentService} from "./dynamic-component.service";

export const DynamicComponentInjectables: Array<any> = [
  {
    provide: DynamicComponentService,
    useClass: DynamicComponentService,
  },
];
